import { CATEGORIES } from '@hivebrite/design-system/FontAwesomeIcon';
import { Tooltip } from '@hivebrite/design-system/Tooltip';

import ToolbarButton from 'hb-builder/components/common/Wrapper/components/ToolbarButton';
import { usePanelContext } from 'hb-builder/hooks';

const ToolbarEdit = ({ tooltipPlace }) => {
  const { displayPanel } = usePanelContext();

  const label = __('Edit');

  return (
    <Tooltip initialPosition={tooltipPlace} childrenElement={label}>
      <ToolbarButton
        iconType={CATEGORIES.REGULAR}
        iconName="pen"
        ariaLabel={label}
        onClick={displayPanel}
      />
    </Tooltip>
  );
};

export default ToolbarEdit;
